<template>
  <section id="dashboard-ecommerce">
    <b-row class="match-height">
      <b-col
        xl="12"
        md="12"
      >
        <dashboard-stats :data="data" :rows="rows" />
      </b-col>
    </b-row>

  </section>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import DashboardStats from './DashboardStats.vue'

export default {
  components: {
    BRow,
    BCol,
    ToastificationContent,

    DashboardStats,
  },
  data() {
    return {
      data: [],
      rows: [],
    }
  },
  created() {
      this.$http.get('/admin/v1/dashboard')
        .then(res => {         
          const data = res.data
          const message = data.message

          if(!data.status) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: `Error`,
                icon: 'CoffeeIcon',
                variant: 'danger',
                text: message,
              },
            })
          }
          else {
            const currentData = res.data.data
          
            this.data = [
              {
                icon: "BarChartIcon",
                color: "light-success",
                title: currentData.total_transactions,
                subtitle: "Total Transaksi",
                customClass: "mb-2 mb-xl-0"
              },
              {
                icon: "BookIcon",
                color: "light-warning",
                title: currentData.total_books,
                subtitle: "Total Buku",
                customClass: "mb-2 mb-xl-0"
              },
              // {
              //   icon: "UserPlusIcon",
              //   color: "light-primary",
              //   title: currentData.total_transactions,
              //   subtitle: "New Users",
              //   customClass: "mb-2 mb-xl-0"
              // },
            ]

            this.rows = currentData.top_books
          }
     })
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/pages/dashboard-ecommerce.scss';
</style>
